import { ReactElement } from 'react';
import './Hero.scss';

function Hero(): ReactElement {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="home">
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Your Manufacturing Systems Integration Partner
          </h1>
          <p className="hero-subtitle">
            Integrate machine monitoring, tool optimization, and measurement
            systems into your existing operations
          </p>
          <div className="hero-buttons">
            <button
              className="btn-primary"
              onClick={() => scrollToSection('contact')}
            >
              Get Started
            </button>
            <button
              className="btn-outline"
              onClick={() => scrollToSection('services')}
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
